export enum ContractRoleEnum {
    GESTIONNAIRE = 'Gestionnaire',
    TITULAIRE = 'Titulaire',
}
